import React, { Component } from 'react';
import moment from 'moment';
import axios from '~/axios';
import { Link } from 'react-router-dom';
import { Button, Card, Row, Col, Modal, Spin, Alert } from 'antd';

import InfoGroup from "../components/schedule/InfoGroup";
import InfoGroupLarge from "../components/schedule/InfoGroupLarge";
import UnscheduledSessionsCard from "../components/schedule/UnscheduledSessionsCard";
import ScheduledSessionsCard from "../components/schedule/ScheduledSessionsCard";

import NotificationModal from '../components/dashboard/NotificationModal';
import NotificationButton from "../components/dashboard/NotificationButton";

export default class Schedule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            showSendDialogSpinner: false,
            showSendDialog: false,
            data: {
                email: '',
                submissionID: '',
            },
            sessions: null,
        }
        this.showSendDialog = this.showSendDialog.bind(this);
        this.closeSendDialog = this.closeSendDialog.bind(this);
        this.sendNotification = this.sendNotification.bind(this);
        this.downloadPDF = this.downloadPDF.bind(this);

        this.fetchData();
    }

    fetchData() {
        axios.get('/api/submission/' + this.props.match.params.submissionID).then(response => {

            const sessions = response.data.data.sessions;

            // Update the remaining state (Scheduled Sessions, loading state)
            this.setState({
                data: response.data.data,
                sessions: sessions,
                loading: false
            });

        }).catch(function (error) {
            console.dir(error);
        });
    }

    showSendDialog(email, submissionID, type) {
        // show the 'send notification' confirmation
        this.setState({ email: email, submissionID: submissionID, showSendDialog: type });
    }

    downloadPDF() {
        // download a PDF
        console.log("pdf");
        try {
            axios.get('/api/schedule/' + this.state.data.submissionID + '/pdf', { responseType: 'arraybuffer' }).then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' });
                console.log(blob);
                let url = window.URL.createObjectURL(blob);
                console.log(url);
                window.open(url);
            });
        } catch ( e ) {
            console.error(e);
        }

    }

    closeSendDialog() {
        // close the 'send notification' confirmation
        this.setState({ email: null, submissionID: null, showSendDialog: false });
    }

    async sendNotification(type) {
        this.setState({ showSendDialogSpinner: true });
        // attempt to send the email using provided data
        await axios.post('/api/notification', {
            'to': this.state.data.email,
            'submissionID': this.state.data.submissionID,
            'type': type,
        }).then((response) => {
            if (response.status == 200) {
                // if the email sent, update the state/view
                Modal.success({
                    title: 'Notification Sent',
                    content: 'The email and schedule were sent to the employee.'
                });
            }
        }).catch((error) => {
            Modal.error({
                title: 'Something Went Wrong',
                content: 'The email could not be sent. Is the email a valid email address?'
            });
        });
        this.setState({ showSendDialogSpinner: false });
        this.closeSendDialog();
    }

    render() {

        return (<Spin spinning={ this.state.loading }>
            <NotificationModal showSendDialog={ this.state.showSendDialog }
                               onOk={ () => this.sendNotification(this.state.showSendDialog) }
                               onCancel={ this.closeSendDialog } spinning={ this.state.showSendDialogSpinner }/>
            <h1>Schedule</h1>
            <Card title='VCH Regional Orientation Schedule' extra={
                <div>
                    <Button onClick={ this.downloadPDF }>View PDF</Button>
                    &nbsp;
                    <Link to={ {
                        pathname: '/registration',
                        state: {
                            submissionID: this.state.data.submissionID
                        }
                    } }>
                        <Button>Edit Schedule</Button>
                    </Link>
                    &nbsp;
                    <NotificationButton submission={ this.state.data }
                                        showSendDialog={ this.showSendDialog }/>
                </div>
            }>
                <h2>Employee and Position Information</h2>
                <Card>
                    <Row gutter={ 16 } style={ { 'marginLeft': 0, 'marginRight': 0 } }>
                        <InfoGroup label='Name' data={ this.state.data.firstName + " " + this.state.data.lastName }/>
                        <InfoGroup label='Employee ID' data={ this.state.data.employeeID }/>
                        <InfoGroup label='Department' data={ this.state.data.department }/>
                        <InfoGroup label="Manager Email" data={ this.state.data.managerEmail }/>
                    </Row>
                    <Row gutter={ 16 } style={ { 'marginLeft': 0, 'marginRight': 0 } }>
                        <InfoGroup label='Email' data={ this.state.data.email }/>
                        <InfoGroup label='Phone' data={ this.state.data.phone }/>
                        <InfoGroup label='Community of Care' data={ this.state.data.coc }/>
                        <InfoGroup label='Sector' data={ this.state.data.sector }/>
                    </Row>
                    <Row gutter={ 16 } style={ { 'marginLeft': 0, 'marginRight': 0 } }>
                        <InfoGroup label='Job Title' data={ this.state.data.jobTitle }/>
                        <InfoGroup label='Work Site' data={ this.state.data.workSite }/>
                        <InfoGroup label='Educator Email' data={ this.state.data.educatorEmail }/>
                        <InfoGroup label='Requester Email' data={ this.state.data.requesterEmail }/>
                    </Row>
                    <Row gutter={ 16 } style={ { 'marginLeft': 0, 'marginRight': 0 } }>
                        <InfoGroup label='Union' data={ this.state.data.union }/>
                        <InfoGroup label='Employment Status' data={ this.state.data.employmentStatus }/>
                        <InfoGroup label='Hire Source' data={ this.state.data.hireSource }/>
                        <InfoGroup label='Employment Start Date' data={ this.state.data.employmentStartDate }/>
                    </Row>
                    {/* Only Show if there is info in at least one of the New Grad Columns */ }
                    { this.state.data.newGradSchool || this.state.data.newGradDate ? (
                        <Row gutter={ 16 } style={ { 'marginLeft': 0, 'marginRight': 0 } }>
                            <InfoGroup label='New Grad School' data={ this.state.data.newGradSchool }/>
                            <InfoGroup label='New Grad Date' data={ this.state.data.newGradDate }/>
                        </Row>) : null }
                    <Row gutter={ 16 } style={ { 'marginLeft': 0, 'marginRight': 0 } }>
                        <InfoGroupLarge label='Notes' data={ this.state.data.notes }/>
                    </Row>
                </Card>

                <h2>Orientation Schedule</h2>
                <Row gutter={ 16 } style={ { 'marginLeft': 0, 'marginRight': 0 } }>
                    { this.state.sessions && <Card>
                        { this.state.sessions.scheduled && Object.entries(this.state.sessions.scheduled).map(([day, sessions]) => {
                            return <ScheduledSessionsCard sessions={ sessions } key={ day }/>
                        }) }

                        { this.state.sessions.unscheduled && Object.entries(this.state.sessions.unscheduled).map(([category, sessions]) => {
                            return <UnscheduledSessionsCard sessions={ sessions } key={ category }/>
                        }) }
                    </Card> }

                </Row>
            </Card>
        </Spin>);
    }
}
